import { render, staticRenderFns } from "./upLoadImgs.vue?vue&type=template&id=309c0396&"
import script from "./upLoadImgs.vue?vue&type=script&lang=js&"
export * from "./upLoadImgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports